export const SET_UI = 'SET_UI'
export const SET_ERROR = 'SET_ERROR'
export const SET_ERROR_TITLE = 'SET_ERROR_TITLE'
export const GET_RESERVATION = 'GET_RESERVATION'
export const GET_RESERVATION_SUCCESS = 'GET_RESERVATION_SUCCESS'
export const GET_RESERVATION_FAILURE = 'GET_RESERVATION_FAILURE'
export const GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY = 'GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY'
export const GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_SUCCESS =
  'GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_SUCCESS'
export const GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_FAILURE =
  'GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_FAILURE'
export const GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE = 'GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE'
export const GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_SUCCESS = 'GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_SUCCESS'
export const GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_FAILURE = 'GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_FAILURE'
export const UPDATE_RESERVATION = 'UPDATE_RESERVATION'
export const UPDATE_RESERVATION_SUCCESS = 'UPDATE_RESERVATION_SUCCESS'
export const UPDATE_RESERVATION_FAILURE = 'UPDATE_RESERVATION_FAILURE'
export const CHECKIN_RESERVATION = 'CHECKIN_RESERVATION'
export const CHECKIN_RESERVATION_SUCCESS = 'CHECKIN_RESERVATION_SUCCESS'
export const CHECKIN_RESERVATION_FAILURE = 'CHECKIN_RESERVATION_FAILURE'
export const SET_RES_ID = 'SET_RES_ID'
export const SET_DRIVER_BIRTH_DATE = 'SET_DRIVER_BIRTH_DATE'
export const SET_DRIVER1_BIRTH_DATE = 'SET_DRIVER1_BIRTH_DATE'
export const SET_CAR_LICENCE_PLATE = 'SET_CAR__LICENCE_PLATE'
export const SET_TRAILER_LICENCE_PLATE = 'SET_TRAILER_LICENCE_PLATE'
export const SET_CARGO_LENGTH = 'SET_CARGO_LENGTH'
export const SET_CARGO_WEIGHT = 'SET_CARGO_WEIGHT'
export const PRINT_SUCCESS = 'PRINT_SUCCESS'
export const PRINT_FAILURE = 'PRINT_FAILURE'
export const SET_DRIVER_FIRST_NAME = 'SET_DRIVER_FIRST_NAME'
export const SET_DRIVER_LAST_NAME = 'SET_DRIVER_LAST_NAME'
export const SET_DRIVER_CITIZENSHIP = 'SET_DRIVER_CITIZENSHIP'
export const SET_DRIVER_GENDER = 'SET_DRIVER_GENDER'
export const SET_CONSIGNEE = 'SET_CONSIGNEE'
export const SET_COUNTRY_FROM = 'SET_COUNTRY_FROM'
export const SET_COUNTRY_TO = 'SET_COUNTRY_TO'
export const SET_CARGO_CONTENT = 'SET_CARGO_CONTENT'
export const SET_DRIVER_DOCUMENT_TYPE = 'SET_DRIVER_DOCUMENT_TYPE'
export const SET_DRIVER_EXPIRATION_DATE = 'SET_DRIVER_EXPIRATION_DATE'
export const SET_DRIVER_DOCUMENT_ISSUED_COUNTRY = 'SET_DRIVER_DOCUMENT_ISSUING_COUNTRY'
export const SET_DRIVER_DOCUMENT_NUMBER = 'SET_DRIVER_DOCUMENT_NUMBER'
export const TRY_GET_RESERVATION_BY_LICENCE_PLATE = 'TRY_GET_RESERVATION_BY_LICENCE_PLATE'
export const CLEAR_RESERVATION = 'CLEAR_RESERVATION'
export const SET_DRIVER_INDEX = 'SET_DRIVER_INDEX'
export const GET_RESERVATION_ORIGIN_SUCCESS = 'GET_RESERVATION_ORIGIN_SUCCESS'
export const UPDATE_TIMEOUT_MESSAGE = 'UPDATE_TIMEOUT_MESSAGE'
export const GET_TERMINAL_INFO_BY_ID = 'GET_TERMINAL_INFO_BY_ID'
export const SET_USER_NOTE = 'SET_USER_NOTE'
export const GET_UI_CONFIG_SUCCESS = 'GET_UI_CONFIG_SUCCESS'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_TOTAL_PAGES_COUNT = 'SET_TOTAL_PAGES_COUNT'
export const SET_RESERVATION_CHANGE = 'SET_RESERVATION_CHANGE'

export const SET_APP_STATE = 'SET_APP_STATE'